module.exports = __webpack_public_path__ + "media/images/fb-b416f38c41c3bf88ca296a6bae8d15a9.svg";